import { useCallback, useEffect, useState } from "react";
import { FaRegCircleCheck } from "react-icons/fa6";
import { MdOutlineCircle } from "react-icons/md";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { RightWrapper } from "../../../components";
import { kycSchema } from "../../../schemas";
import {
  useValidation,
  useConfirmationDialog,
  useApi,
  useFormData,
  useAlert,
} from "@/";
import { useDispatch, useSelector } from "react-redux";
import { customerToggle, fetchCustomerKycDetails } from "../../../app/Slices";
import axios from "axios";

const StepperContainer = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { alert, AlertDialog } = useAlert();
  const { confirm, ConfirmationModal } = useConfirmationDialog();
  const { loading, error, callApi } = useApi();
  const { validate } = useValidation(kycSchema);
  const convertToFromData = useFormData();

  // Sets for tracking completed and skipped steps
  const [completedSteps, setCompletedSteps] = useState(new Set());
  const [skippedSteps, setSkippedSteps] = useState(new Set());
  const [activeStep, setActiveStep] = useState(1);
  const [isDisabled, setIsDisabled] = useState(true);

  const initialState = {
    data: {
      personalDetails: {
        fullName: "",
        dob: "",
        gender: "",
        phone1: "",
        phone2: "",
        email: "",
        monthlyShipments: "",
        address: {
          line1: "",
          city: "",
          state: "",
          pincode: "",
        },
        panNumber: "",
        aadharNumber: "",
      },
      businessDetails: {
        firmName: "",
        businessType: "",
        phone: "",
        address: {
          line1: "",
          city: "",
          state: "",
          pincode: "",
        },
        gstNumber: "",
        firmPanNumber: "",
      },
      bankDetails: {
        accountHolderName: "",
        bankName: "",
        accountNumber: "",
        accountType: "",
        ifscCode: "",
      },
      kycDocuments: {
        aadhar: "",
        pan: "",
        cancelledCheque: "",
        firmLOGO: "",
        firmPan: "",
        firmGST: "",
      },
      kycStatus: "not_submitted",
    },
  };
  const [formData, setFormData] = useState(initialState);
  const [formDataCopy, setFormDataCopy] = useState(initialState);

  const fetchData = useCallback(async () => {
    if (!id) return; // Ensure id is available before fetching

    try {
      const response = await dispatch(fetchCustomerKycDetails({ userId: id }));

      console.log("response::::-----", response.payload);

      if (fetchCustomerKycDetails.fulfilled.match(response)) {
        if (response.payload.businessDetails?.address?.line1 === null) {
          setSkippedSteps((prev) => new Set([...prev, 2]));
          console.log("Skippeed::::::::", skippedSteps);
        }
        /*  const personalDetails = { ...response.payload?.personalDetails };
        delete personalDetails.phone; // Remove phone array before spreading */

        /*    const body = {
          personalDetails: {
            fullName: response.payload?.personalDetails?.fullName || "",
            dob: response.payload?.personalDetails?.dob || "", // ✅ Ensure DOB is set
            gender: response.payload?.personalDetails?.gender || "",
            phone1:
              response.payload?.personalDetails?.phone?.[0]?.phoneNumber || "",
            phone2:
              response.payload?.personalDetails?.phone?.[1]?.phoneNumber || "",
            email: response.payload?.personalDetails?.email || "",
            monthlyShipments:
              response.payload?.personalDetails?.monthlyShipments || "", // ✅ Monthly shipments
            address: {
              line1:
                response.payload?.personalDetails?.addressId?.lines?.[0]
                  ?.line1 || "", // ✅ Address line 1
              city: response.payload?.personalDetails?.addressId?.city || "", // ✅ City
              state: response.payload?.personalDetails?.addressId?.state || "", // ✅ State
              pincode:
                response.payload?.personalDetails?.addressId?.pincode || "", // ✅ Pincode
            },
            panNumber: response.payload?.personalDetails?.panNumber || "",
            aadharNumber: response.payload?.personalDetails?.aadharNumber || "",
          },
          ...(response.payload.businessDetails !== undefined
            ? {
                businessDetails: {
                  firmName: response.payload?.businessDetails?.firmName || "",
                  businessType:
                    response.payload?.businessDetails?.businessType || "",
                  phone: response.payload?.businessDetails?.phone || "",
                  address: {
                    line1:
                      response.payload?.businessDetails?.addressId?.lines?.[0]
                        ?.line1 || "",
                    city:
                      response.payload?.businessDetails?.addressId?.city || "",
                    state:
                      response.payload?.businessDetails?.addressId?.state || "",
                    pincode:
                      response.payload?.businessDetails?.addressId?.pincode ||
                      "",
                  },
                  gstNumber: response.payload?.businessDetails?.gstNumber || "",
                  firmPanNumber:
                    response.payload?.businessDetails?.firmPanNumber || "",
                },
              }
            : {}),

          bankDetails: {
            accountHolderName:
              response.payload?.bankDetails?.accountHolderName || "",
            bankName: response.payload?.bankDetails?.bankName || "",
            accountNumber: response.payload?.bankDetails?.accountNumber || "",
            accountType: response.payload?.bankDetails?.accountType || "",
            ifscCode: response.payload?.bankDetails?.ifscCode || "",
          },

          kycStatus: response.payload?.status || "",
          ...response.payload?.kycDocuments, // ✅ KYC documents remain at the top level
        }; */

        console.log("Customer KYC Details Fulfilled:", response);
        setFormData(response.payload);
        setFormDataCopy(response.payload);
      } else if (fetchCustomerKycDetails.rejected.match(response)) {
        await alert(response.payload || "Error fetching Customer KYC Details");
        console.log("Customer KYC Details Rejected:", response);
      }
    } catch (error) {
      console.error("Error fetching Customer KYC Details:", error);
    }
  }, [dispatch, id]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const kycStatus = formData?.kycStatus || "";

  const steps = [
    { name: "Personal Details", id: 1, path: "personal" },
    { name: "GST Details", id: 2, path: "gst" },
    { name: "Bank Details", id: 3, path: "bank" },
    { name: "Seller Agreement", id: 4, path: "sellerAgreement" },
  ];

  useEffect(() => {
    if (location.pathname === `/customer/details/${id}/kycDetails`) {
      navigate(`/customer/details/${id}/kycDetails/personal`);
    }
  }, [location.pathname]);

  useEffect(() => {
    setActiveStep(
      steps.findIndex((step) => location.pathname.includes(step.path)) + 1
    );
  }, [location.pathname]);

  const handleNextStep = () => {
    if (activeStep < steps.length) {
      setCompletedSteps((prev) => new Set([...prev, activeStep]));
      // Remove the current step from skipped if it was previously skipped
      setSkippedSteps((prev) => {
        const newSet = new Set(prev);
        newSet.delete(activeStep);
        return newSet;
      });
      setActiveStep((prev) => prev + 1);
      // setIsDisabled(true);
      navigate(steps[activeStep].path);
    }
  };

  const handleSkipStep = () => {
    if (activeStep < steps.length) {
      setSkippedSteps((prev) => new Set([...prev, activeStep]));
      setActiveStep((prev) => prev + 1);
      navigate(steps[activeStep].path);
    }
  };

  const handlePreviousStep = () => {
    if (activeStep > 1) {
      setCompletedSteps((prev) => {
        const newSet = new Set(prev);
        newSet.delete(activeStep - 1);
        return newSet;
      });
      setActiveStep((prev) => prev - 1);
      navigate(steps[activeStep - 2].path);
    }
  };
  const handleIsEdit = () => {
    setIsDisabled(false); // Enable editing by setting isDisabled to false
    // Additional edit mode logic can be added here
  };
  const handleIsCancel = () => {
    setIsDisabled(true); // Disable editing by setting isDisabled to true
    setFormData(formDataCopy);
  };

  const getFileExtension = (file) =>
    file instanceof File && file.name.includes(".")
      ? file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase()
      : "";

  // Encapsulated submission logic
  const submitForm = async (status) => {
    console.log("[FORM DATA]", formData);

    const data = {
      personalDetails: {
        ...formData.personalDetails,
      },
      ...(skippedSteps.has(2)
        ? {}
        : {
            businessDetails: {
              ...formData.businessDetails,
            },
          }),
      bankDetails: {
        ...formData.bankDetails,
        confirmAccountNumber: formData.bankDetails.accountNumber,
      },
      kycDocuments: {
        ...formData.kycDocuments,
      },
      kycStatus: formData.kycStatus,
    };
    console.log("[DATA]", data);
    const result = validate(data);
    console.log("Validation result:", result);
    if (!result.isValid) {
      const errordata = result.error.flatten().fieldErrors;
      console.log("Validation errors:", errordata);
      const errorMessages = Object.values(errordata).flat().join("\n");
      window.alert(errorMessages);
      return;
    }
    console.log("Validated Data:", result.data);

    try {
      const filesToUpload = Object.entries(
        result.data?.kycDocuments || {}
      ).reduce((acc, [key, value]) => {
        if (value instanceof File) {
          acc[key] = value;
        }
        return acc;
      }, {});

      console.log("Files To Upload", filesToUpload);

      const docs = Object.entries(filesToUpload || {}).reduce(
        (acc, [key, file]) => {
          acc[key] = getFileExtension(file);
          return acc;
        },
        {}
      );

      const uploadData = {
        docs,
        clientId: formData?.clientId || "",
      };

      console.log("uploadData", uploadData);

      if (!isDisabled && Object.keys(filesToUpload).length > 0) {
        const uploadDataResponse = await callApi(
          "/admin/customer/upload/kyc",
          "POST",
          uploadData
        );
        console.log("uploadDataResponse>>>", uploadDataResponse);

        if (!uploadDataResponse.success) {
          alert(uploadDataResponse.error.message || uploadDataResponse.error);
          return;
        }

        const responses = await Promise.all(
          uploadDataResponse?.data?.presignedUrls.map(async (object) => {
            const response = await axios.put(
              object.url,
              filesToUpload[object.doc],
              {
                headers: {
                  "Content-Type": filesToUpload[object.doc].type,
                },
              }
            );
            return response;
          })
        );

        console.log("responses>>>", responses);
      }

      const finalData = {
        ...result.data,
        kycDocuments: { ...docs },
        clientId: formData?.clientId,
      };
      console.log("Final Data:", finalData);

      const response = await callApi(
        "/admin/customer/updateKyc",
        "POST",
        finalData,
        { userId: id, status }
      );

      if (response.success) {
        console.log("KYC updated successfully:", response.data);
        await alert("KYC updated successfully.");
        navigate("/customer");
      } else {
        console.log("KYC update failed:", response);
        await alert(
          response?.error || response?.error?.message || "KYC updation failed"
        );
      }
    } catch (error) {
      console.error("Unexpected error during KYC update:", error);
      await alert("An unexpected error occurred during KYC update.");
    }
  };

  const handleSubmit = async () => {
    try {
      await confirm("Are you sure you want to approve this kyc?");
      submitForm("approved");
    } catch (e) {
      console.log("Submission cancelled");
      alert("Submission cancelled");
    }
  };

  const handleIsReject = async () => {
    try {
      await confirm("Are you sure you want to reject this kyc?");
      const response = await callApi(
        "/admin/customer/updateKycStatus",
        "POST",
        {
          userId: formData?.clientId,
          status: "rejected",
        }
      );

      if (response?.success) {
        console.log("KYC rejected successfully:", response.data);
        await alert("KYC rejected successfully.");
        navigate("/customer");
      } else {
        await alert("Failed to approve KYC. : ", response.error.message);
      }
    } catch (e) {
      console.log("Submission cancelled");
      await alert("Submission cancelled");
    }
  };
  const handleApprove = async () => {
    try {
      await confirm("Are you sure you want to approve this kyc?");
      const response = await callApi(
        "/admin/customer/updateKycStatus",
        "POST",
        {
          userId: formData?.clientId,
          status: "approved",
        }
      );

      if (response?.success) {
        console.log("KYC approved successfully:", response.data);
        await alert("KYC approved successfully.");
        navigate("/customer");
      } else {
        await alert("Failed to approve KYC. : ", response.error.message);
      }
    } catch (e) {
      console.log("Submission cancelled");
      alert("Submission cancelled");
    }
  };
  const handleBlock = async () => {
    if (!id) {
      await alert("User ID is required to block a customer.");
      return;
    }

    try {
      const response = await dispatch(
        customerToggle({ userId: id, isActive: false })
      );

      if (customerToggle.fulfilled.match(response)) {
        await confirm("Customer blocked successfully.");
      } else {
        console.error("Failed to block customer", response.payload);
        await alert(response.payload || "Failed to block customer.");
      }
    } catch (error) {
      console.error("Error blocking customer:", error);
      await alert("An error occurred while blocking the customer.");
    }
  };

  const handleUnblock = async () => {
    if (!id) {
      await alert("User ID is required to Unblocked a customer.");
      return;
    }

    try {
      const response = await dispatch(
        customerToggle({ userId: id, isActive: true })
      );

      if (customerToggle.fulfilled.match(response)) {
        await confirm("Customer Unblocked successfully.");
      } else {
        console.error("Failed to Unblocked customer", response.payload);
        await alert(response.payload || "Failed to Unblocked customer.");
      }
    } catch (error) {
      console.error("Error Unblocked customer:", error);
      await alert("An error occurred while Unblocked the customer.");
    }
  };

  return (
    <RightWrapper>
      <div className="flex gap-4 h-[calc(100%-4px)] md:pb-0">
        {/* Sidebar */}
        <div className="hidden md:flex h-full md:w-56 bg-secondary/5 flex-col gap-6 p-6 rounded-xl">
          <h2 className="text-subtitle1 font-ptsans text-secondary/60">{`Step ${activeStep}/4`}</h2>
          <ul className="flex flex-col gap-4 mt-8">
            {steps.map((step) => {
              const isActive = activeStep === step.id;
              const isCompleted =
                kycStatus === "approved" ? true : completedSteps.has(step.id);
              const isSkipped = skippedSteps.has(step.id);
              return (
                <li
                  key={step.id}
                  onClick={() => {
                    if (isCompleted) navigate(step.path);
                  }}
                  className={`flex items-center space-x-2 ${
                    isActive
                      ? "text-secondary/75"
                      : isCompleted
                      ? "text-secondary/50"
                      : "text-secondary/30"
                  }`}
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    {isCompleted ? (
                      <FaRegCircleCheck size={24} className="text-ternary" />
                    ) : (
                      <MdOutlineCircle
                        size={24}
                        className={
                          isActive ? "text-secondary/75" : "text-secondary/30"
                        }
                      />
                    )}
                  </div>
                  <span>{step.name}</span>
                  {isSkipped && (
                    <span className="ml-2 text-xs text-red-600 bg-red-200/60 px-1.5 py-[1.8px] border font-nunito border-red-600/20 rounded-[8px] leading-4">
                      Skipped
                    </span>
                  )}
                </li>
              );
            })}
          </ul>

          {kycStatus && (
            <div className="mt-8">
              <div
                className={`px-3 py-2 rounded-lg border border-dashed ${
                  kycStatus === "approved"
                    ? "bg-green-100/40 text-green-800/90 border-green-800/20"
                    : kycStatus === "pending"
                    ? "bg-yellow-100/40 text-yellow-800/90 border-yellow-800/20"
                    : "bg-red-100/40 text-red-800/90 border-red-800/20"
                }`}
              >
                {kycStatus === "approved" && (
                  <span className="text-xs font-nunito">
                    Customer KYC is Approved
                  </span>
                )}
                {kycStatus === "pending" && (
                  <span className="text-xs font-nunito">
                    Customer KYC is Pending
                  </span>
                )}
                {kycStatus === "rejected" && (
                  <span className="text-xs font-nunito">
                    Customer KYC is Rejected
                  </span>
                )}
              </div>
            </div>
          )}
        </div>

        {/* Main Content */}
        <div className="w-full h-full flex-1 overflow-y-auto ">
          <Outlet
            context={{
              formData,
              setFormData,
              handleNextStep,
              handlePreviousStep,
              handleSkipStep,
              handleSubmit,
              handleIsEdit,
              handleIsCancel,
              handleIsReject,
              handleApprove,
              isDisabled,
              kycStatus,
              handleBlock,
              handleUnblock,
              skippedSteps,
            }}
          />
        </div>
      </div>

      {/* Render the modal once at the root of this component */}
      <ConfirmationModal />
      <AlertDialog />
    </RightWrapper>
  );
};

export default StepperContainer;
